import { Badge, Card } from '../ui/primitives';
import type { OperationsView } from '../../utils/reports/operationsView';
import { ReportsNotes, ReportsSay } from './ReportsParts';
import { ReportsDetail, ReportsEmpty, ReportsSection, ReportsStats } from './ReportsPieces';

/**
 * P-084 · R7 «¿Cómo va la operación?». Solo dibuja `OperationsView`: la frase con el estado (una insignia, no un
 * puntaje), cuatro cifras, «Qué revisar» con cada señal y su destino, y el detalle de cortes, anulaciones y solicitudes.
 */
export function ReportOperations({ view, onNavigate }: { view: OperationsView; onNavigate: (destination: string) => void }) {
  if (view.empty) {
    return (
      <>
        <ReportsSay segments={view.say} />
        <ReportsEmpty description={view.empty.description} title={view.empty.title} />
        <ReportsNotes notes={view.notes} />
      </>
    );
  }
  return (
    <>
      <ReportsSay segments={view.say} />
      <div className="n3-reports__state-row">
        <Badge dot tone={view.state.tone}>{view.state.label}</Badge>
      </div>
      <Card aria-labelledby="reports-operations-stats" as="section">
        <h2 className="n3-visually-hidden" id="reports-operations-stats">Cortes, diferencia de caja, anuladas y pendientes</h2>
        <ReportsStats stats={view.stats} />
      </Card>
      <ReportsSection icon="drawer" onNavigate={onNavigate} section={view.signals} tone="info" />
      <ReportsDetail id="reports-operations-detail">
        {view.detail.map((section) => <ReportsSection icon="shift" key={section.key} onNavigate={onNavigate} section={section} tone="info" />)}
      </ReportsDetail>
      <ReportsNotes notes={view.notes} />
    </>
  );
}
